/* Oct 13 2026 — product card "Buy now": add this item, then straight to checkout.
   Anything already in the cart stays in the order. On failure, falls back to the product page. */
(function () {
  if (window.__ggCardBuyNow) return; window.__ggCardBuyNow = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-buy-now-id]'); if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('busy')) return;
    var id = parseInt(btn.getAttribute('data-buy-now-id'), 10); if (!id) return;
    btn.classList.add('busy');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); window.location.href = '/checkout'; })
      .catch(function () { btn.classList.remove('busy'); var f = btn.getAttribute('data-fallback'); if (f) window.location.href = f; });
  });
})();
